import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPostDownload, doPut } from './utils'

// const API_ROOT = 'http://localhost:80/api'

export const getDashboardLanding = () => {
  const url = `${API_ROOT}/dashboard/department-6/page`
  return doGet(url)
}

export const getOverAllNodeProjectsSchema = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/over-all-node`
  return doGet(url)
}

export const searchOverAllNodeProjectsSchema = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/over-all-node`
  return doPost(url, request)
}

export const getBasicKnowledgeAndSkillsAssScore = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/basicknowkedge-skill-assscore`
  return doGet(url)
}

export const searchBasicKnowledgeAndSkillsAssScore = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/basicknowkedge-skill-assscore`
  return doPost(url, request)
}

export const getProjectsDevelopment = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/projects-development`
  return doGet(url)
}

export const searchProjectsDevelopment = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/projects-development`
  return doPost(url, request)
}

export const getActionResearchEvaluation = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/action-research-evaluation`
  return doGet(url)
}

export const searchActionResearchEvaluation = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/action-research-evaluation`
  return doPost(url, request)
}

export const getCommunityCoalitionActionTheory = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/community-coalition-action-theory`
  return doGet(url)
}

export const searchCommunityCoalitionActionTheory = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/community-coalition-action-theory`
  return doPost(url, request)
}

export const getPartnershipAssessmentTools = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/partnership-assessment-tools`
  return doGet(url)
}

export const searchPartnershipAssessmentTools = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/partnership-assessment-tools`
  return doPost(url, request)
}

export const getOverAllOperations4areas = () => {
  const url = `${API_ROOT}/dashboard/department-6/page/over-all-operations-4areas`
  return doGet(url)
}

export const searchOverAllOperations4areas = (request) => {
  const url = `${API_ROOT}/dashboard/department-6/search/over-all-operations-4areas`
  return doPost(url, request)
}
